/**
 * Outcome of one §302 Abrechnungsfall inside an `Abrechnungslauf`
 * (TM-9538 / #1519). One item is one Verordnung — the grain the run bills.
 *
 * - `PENDING` — created with the run, not yet processed.
 * - `SUCCESS` — the Fall went into a Nutzdatendatei that was written.
 * - `SKIPPED` — the Fall was set aside; `skipReason` says by what. A human
 *   deselecting it (`abgewählt`) lands here just as a rule does, which is the
 *   point: afterwards it is still recorded **who** left it out.
 * - `FAILED` — an exception escaped while the Fall was being processed;
 *   `errorMessage` is set. A `FAILED` item does not promote the run to `FAILED`.
 *
 * ⚠ **`SKIPPED` is not `FAILED`.** A Fall that was never meant to go out and a
 * Fall that broke are two different answers to *'why did this not arrive at the
 * Kasse'*, and collapsing them would make the run's own count of
 * what it sent unreadable.
 */
export var GkvBillingRunItemStatus;
(function (GkvBillingRunItemStatus) {
    GkvBillingRunItemStatus["PENDING"] = "pending";
    GkvBillingRunItemStatus["SUCCESS"] = "success";
    GkvBillingRunItemStatus["SKIPPED"] = "skipped";
    GkvBillingRunItemStatus["FAILED"] = "failed";
})(GkvBillingRunItemStatus || (GkvBillingRunItemStatus = {}));
//# sourceMappingURL=gkv-billing-run-item-status.enum.js.map